import React from 'react';
import { Col } from "react-bootstrap";
import { Box, Button, Card, CardActions, CardContent, Typography, Link, makeStyles } from "@material-ui/core";
import IconHolder from "../IconHolder";
import { NeedsAnalysisList } from '../../Helpers/Lists/NeedsAnalysisList';
import { useHistory } from "react-router-dom";
import { SESSION_STORAGE_NEEDS_ANALYSIS_KEY, ADVISOR_OBJECT_KEY, getSessionStorageItem } from '../../../sessionStorage';
import { v4 as uuid } from 'uuid';
import HandleNavigateToLicensingAndAppointmentLink from '../../Helpers/HandleNavigateToLicensingAndAppointmentLink';

const useStyles = makeStyles((theme) => ({
  cardContent: {
    padding: '15px 15px 0 15px !important',
  }
})
)

const ToolButtons = ({ isHomePage }) => {
  const classes = useStyles();
  const history = useHistory();
  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  const insuranceSpecialistURL = advisorObj && advisorObj.insuranceSpecialistURL;

  const generateInsuranceSpecialistUrl = () => {
    const uniqueID = uuid();
    return `${insuranceSpecialistURL}?ApplicationID=${uniqueID}`;
  }
   
  const redirectToLandingPage = (path) => {
    if (path) {
      sessionStorage.removeItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY);
      history.push(path);
    }
  }

  const redirectToMsPage = (item) => {
    let path = ''
    if (item.key === 'morgan-stanley-insurance-licensing-tool') {
       path = HandleNavigateToLicensingAndAppointmentLink();
    }
    if(item.key === 'morgan-stanley-insurance-specialist-page') {
       path = generateInsuranceSpecialistUrl();
    }
    if(path !== undefined && path !== null) {
      window.location.href = path;
    }
  }

  return (
    <React.Fragment>
      {NeedsAnalysisList.map((item, index) => (
        item.isShowOnHomePage &&
        <Col key={index} md="auto" className="pr-0 pb-5">
          <Card className={`card-vertical d-flex flex-column`} variant="elevation">
            <CardContent className={`${classes.cardContent} ${isHomePage && 'pointerDiv'}`}
              onClick={!item.isRedirectLink ? () => redirectToLandingPage(`${item.href}`) : () => redirectToMsPage(item)}>
              <div className="d-flex justify-content-center">
                <IconHolder icon={item.icon} viewBox="0 0 24 24" />
              </div>
              <Typography variant="body1" component="div" align="center" className="mt-1 p-2">
                <Box fontWeight="fontWeightBold" fontSize={15}>
                  {item.name}
                </Box>
              </Typography>
            </CardContent>
            <CardActions className="d-block mt-auto">
              <div className="d-flex justify-content-center">
                  <Link to="#" className="link-button">
                    <Button color="primary" className='link-btn-padding' variant="text"  onClick={!item.isRedirectLink ? () => redirectToLandingPage(`${item.href}`) : () => redirectToMsPage(item)}>START</Button>
                  </Link>
              </div>
            </CardActions>
          </Card>
        </Col>
      ))
      }
    </React.Fragment >
  )
}

export default ToolButtons;


// WEBPACK FOOTER //
// ./src/components/Common/ToolButtons/ToolButtons.js